var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.1536 21.2814V24.8711C21.1536 25.3472 20.9645 25.8037 20.6279 26.1403C20.2913 26.4769 19.8348 26.666 19.3587 26.666H6.79484C6.31882 26.666 5.8623 26.4769 5.5257 26.1403C5.1891 25.8037 5 25.3472 5 24.8711V5.12785C5 4.65183 5.1891 4.1953 5.5257 3.85871C5.8623 3.52211 6.31882 3.33301 6.79484 3.33301H19.3587C19.8348 3.33301 20.2913 3.52211 20.6279 3.85871C20.9645 4.1953 21.1536 4.65183 21.1536 5.12785V8.71754",
    stroke: "#FC4E52",
    strokeWidth: 2.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.7695 14.999H28.3334",
    stroke: "#FC4E52",
    strokeWidth: 2.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.7432 11.4102L28.3329 14.9998L24.7432 18.5895",
    stroke: "#FC4E52",
    strokeWidth: 2.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/logout.91fa4a5f8e4f95bb52ec63aacedfcfe7.svg";
export { ForwardRef as ReactComponent };